import { LoadingIndicator } from "@jsq/ds/core";
import { FormSelect, useFormContext } from "@jsq/ds/forms";
import { FormFieldConfig } from "~/pages/Compliance/CaseDetailsDrawer/Documents/TaxForms";
import { TaxFormValues } from "~/pages/Compliance/CaseDetailsDrawer/Documents/TaxForms/types";
import { AIFieldLabel } from "../../../../../Common/AIFieldLabel";
import { AddressFieldNames } from "../constants";
import { useCountryOptions } from "./useCountryOptions";

type CountryFormFieldProps = {
  populatedByAI?: boolean;
  field?: FormFieldConfig;
  placeholder?: string;
  full?: boolean;
  hideLabel?: boolean;
};

const CountryFormField = ({
  populatedByAI = false,
  field,
  placeholder,
  full,
  hideLabel = false,
}: CountryFormFieldProps) => {
  const { loading, countryOptions } = useCountryOptions();
  const { values } = useFormContext<TaxFormValues>();

  const resolvedLabel = typeof field?.label === "function" ? field.label(values) : field?.label;

  const label = field ? (
    resolvedLabel
  ) : (
    <AIFieldLabel label="Country" showIcon={populatedByAI} />
  );

  return (
    <>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <FormSelect
          name={field?.name ?? AddressFieldNames.Country}
          label={label}
          placeholder={placeholder ?? field?.placeholder}
          disabled={field?.disabled}
          required={field?.required}
          aria-label="country"
          role="combobox"
          full={full ?? Boolean(field?.gridColumn)}
          hideLabel={hideLabel}
          data-testid="country"
        >
          <FormSelect.Section>
            {countryOptions.map((country) => (
              <FormSelect.Option key={country.id} value={country.code}>
                {country.name}
              </FormSelect.Option>
            ))}
          </FormSelect.Section>
        </FormSelect>
      )}
    </>
  );
};

export default CountryFormField;
